$(function(){
	/*$('.product-info').append($('.product-single__description .prodDetTable'));*/
	$('.product-other-info.pc .product-other-info-block-header').on('click', function(){
		var index = $('.product-other-info.pc .product-other-info-block-header').index(this);
		
		$(this).parents('.product-other-info').find('.product-other-info-block-header:not(:eq('+index+'))').removeClass('is-open');
		$(this).parents('.product-other-info').find('.product-other-info-block-body:not(:eq('+index+'))').hide();
		$(this).parents('.product-other-info').find('.product-other-info-block-body:not(:eq('+index+'))').removeClass('is-open');
		
		$(this).toggleClass('is-open');
		$(this).parents('.product-other-info').find('.product-other-info-block-body').eq(index).slideToggle();
		$(this).parents('.product-other-info').find('.product-other-info-block-body').eq(index).toggleClass('is-open');
		return false;
	});
	$('.product-other-info.sp .product-other-info-block-header').on('click', function(){
		$(this).parent().toggleClass('is-open');
		$(this).toggleClass('is-open');
		$(this).next('.product-other-info-block-body').slideToggle();
		$(this).next().toggleClass('is-open');
		return false;
	});
	
// $(window).on('load',function(){
//   $('.product-template_konstella .product-form__btnBox').remove();
// });
	
});

